export default {
  list: {
    headers: {
      id: "ID",
      title: "Tytul",
      titleBold: "Wyroznienie",
      startAt: "Start",
      endAt: "Koniec",
      image: "Obraz",
    },
  },
  form: {
    labels: {
      title: "Tytul",
      titleBold: "Wyrozniona czesc tytulu",
      description: "Opis",
      googleCalendarLink: "Link Google Calendar",
      outlookCalendarLink: "Link Outlook Calendar",
      calendlyLink: "Link Calendly",
      startAt: "Start",
      endAt: "Koniec",
      image: "Obraz",
      video: "Video",
      currentImageHint: "Aby podmienic obraz, wybierz nowy plik.",
      videoUploadAfterSave: "Upload video bedzie dostepny po zapisaniu rekordu.",
      videoUploaded: "Video zostalo pomyslnie dodane.",
      videoUploadedFile: "Plik zostal pomyslnie dodany:",
    },
    buttons: {
      add: "Dodaj live session",
      edit: "Zapisz zmiany",
    },
  },
};
